import cx from 'classnames';

export type LoginStatus = 'logged-in' | 'never-logged-in' | 'unknown';

type LoginStatusInput = {
    hasEverLoggedIn?: boolean;
    lastLoggedInAt?: string;
};

export const getLoginStatus = ({
    hasEverLoggedIn,
    lastLoggedInAt,
}: LoginStatusInput): LoginStatus => {
    if (hasEverLoggedIn === true) {
        return 'logged-in';
    }

    if (hasEverLoggedIn === false) {
        return 'never-logged-in';
    }

    if (lastLoggedInAt) {
        return 'logged-in';
    }

    return 'unknown';
};

const statusLabel: Record<LoginStatus, string> = {
    'logged-in': 'Has logged in before',
    'never-logged-in': 'Has never logged in',
    unknown: 'Login status unknown',
};

const statusDotClassName: Record<LoginStatus, string> = {
    'logged-in': 'border-[#2F9E44] bg-[#EAF7ED]',
    'never-logged-in': 'border-[#C88700] bg-[#FFF3C4]',
    unknown: 'border-mongooseGray bg-vanillaWhite',
};

export const LoginStatusIndicator = ({
    hasEverLoggedIn,
    lastLoggedInAt,
    className,
    size = 'default',
}: LoginStatusInput & { className?: string; size?: 'default' | 'avatar' }) => {
    const status = getLoginStatus({ hasEverLoggedIn, lastLoggedInAt });
    const label = statusLabel[status];

    return (
        <span
            aria-label={label}
            className={cx(
                'inline-block flex-shrink-0 rounded-full border-2',
                size === 'avatar' ? 'h-4 w-4' : 'h-3.5 w-3.5',
                statusDotClassName[status],
                className,
            )}
            role="img"
            title={label}
        />
    );
};
